/**
 * mk-cart-drawer-garde.js — empêche le tiroir panier de rester blanc.
 *
 * Le tiroir est re-rendu par plusieurs chemins (suppression dans cart.js,
 * ajout via product-form / cart-drawer.js, mk-legacy-atc, code promo, upsell,
 * cadeau ajouté par une app). Aucun ne gère la classe `is-empty` de façon
 * fiable, et deux requêtes qui se croisent peuvent laisser l'ancien rendu
 * « panier vide » par-dessus un panier rempli. Dawn masque alors l'en-tête,
 * la barre de paliers et les lignes : il ne reste que le pied du tiroir.
 *
 * Ici on observe le tiroir. Après chaque changement :
 *  1. `is-empty` est recalculé d'après les lignes réellement affichées ;
 *  2. on compare avec /cart.js ; si l'affichage ne correspond pas au vrai
 *     panier (lignes absentes alors qu'il y a des articles, ou l'inverse),
 *     le tiroir est re-rendu depuis le serveur.
 */
(function () {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  let timer = null;
  let enCours = false;
  let rendus = []; // horodatages des re-rendus, pour éviter toute boucle

  function aDesLignes() {
    return !!drawer.querySelector('.mk-item');
  }

  function synchroniserClasses() {
    const vide = !aDesLignes() && !!drawer.querySelector('.drawer__inner-empty');
    drawer.classList.toggle('is-empty', vide);
    const items = drawer.querySelector('cart-drawer-items');
    if (items) items.classList.toggle('is-empty', vide);
    const inner = drawer.querySelector('.drawer__inner');
    if (inner && !vide) inner.classList.remove('is-empty');
  }

  function rerendre() {
    const maintenant = Date.now();
    rendus = rendus.filter((t) => maintenant - t < 10000);
    if (rendus.length >= 3) return Promise.resolve();
    rendus.push(maintenant);

    return fetch(`${cartUrl()}?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((html) => {
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        const target = document.querySelector('#CartDrawer');
        if (!source || !target) return;
        target.innerHTML = source.innerHTML;
        // L'overlay a été remplacé : on rebranche la fermeture.
        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        synchroniserClasses();
      });
  }

  function verifier() {
    synchroniserClasses();
    if (enCours) return;
    enCours = true;
    fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const lignesDom = aDesLignes();
        const videDom = !!drawer.querySelector('.drawer__inner-empty');
        const panierRempli = cart.item_count > 0;
        // Panier rempli mais aucune ligne affichée, ou panier vide sans
        // message « panier vide » : l'affichage est périmé.
        if ((panierRempli && !lignesDom) || (!panierRempli && (lignesDom || !videDom))) {
          return rerendre();
        }
      })
      .catch(() => {})
      .finally(() => {
        enCours = false;
      });
  }

  function planifier() {
    synchroniserClasses();
    clearTimeout(timer);
    timer = setTimeout(verifier, 400);
  }

  new MutationObserver(planifier).observe(drawer, { childList: true, subtree: true });

  // Ouverture du tiroir : dernier contrôle au moment où le client regarde.
  new MutationObserver(() => {
    if (drawer.classList.contains('active')) planifier();
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
